/* eslint-disable no-console */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import React, {
  useContext, useEffect, useRef, useMemo
} from 'react'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'
import Name from '@apps/components/Name'
import Heading2 from '@apps/components/Typography/Heading2'
import PIN from '@apps/components/PIN'
import PreferredLanguage from '@apps/components/PreferredLanguage'
import { useDispatch, useSelector } from 'react-redux'
import {
  ACCOUNT_SETUP_STATE,
  updateAccountSetupState,
  updateAccountSetupPinErrorState
} from '@apps/redux/features/AccountSetupSlice'
import AccountSetupChangeHandlers, {
  ACCOUNT_SETUP_EVENTS
} from '@apps/utils/ChangeHandlers/AccountSetupChangeHandlers'
import { logIn } from '@apps/redux/features/CommonSlice'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'
import { setPageAnalytics } from '@apps/utils/Analytics'
import { ANALYTICS_EVENT_TYPES, LANGUAGES_CODE, PAGE_NUMBER } from '@apps/utils/constants'
import {
  APPLICATION_STATE,
  ApplicationContext,
  setLoggedInUser,
  setLandingLogicLoader
} from '@apps/contexts/ApplicationContext'
import { getShortTextFromPage, getById, getBySlug } from '@apps/utils/contentful'
import Sites from '@sites/index'
import CheckoutLayout from '@apps/components/CheckoutLayout'
import {
  Button,
  Card,
  Divider,
  Spacer
} from '@telus/koodo-ui-kit'
import useTagManagerInfo from '../../_engine/hooks/useTagManagerInfo'

const AccountSetupPage = () => {
  const dispatch = useDispatch()
  const { pageContent, featureFlags } = useSelector((state) => state.common.content)
  const {
    userType,
    user: { email, accountInfo },
    quote: { quoteInfo }
  } = useSelector((state) => state.common)
  const { plan } = useSelector((state) => state.plansPage)
  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.SERVICES]: brandServices,
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const { setPatchQuote } = brandServices

  const isDealer = useMemo(() => {
    return userType === Sites.dealer
  }, [userType])

  const text = useMemo(() => {
    if (!pageContent || !language || !userType) return {}
    const contentSuffix = isDealer ? 'Dealer' : 'Consumer'
    const accountSetupPageContent = getById(pageContent, `accountSetupPage${contentSuffix}`)?.[
      language
    ]
    const commonElements = getById(pageContent, 'commonElements')?.[language]
    return {
      accountSetupHeader: getShortTextFromPage(accountSetupPageContent, 'accountSetupHeader'),
      emailInUse: getShortTextFromPage(accountSetupPageContent, 'emailInUse'),
      emailInvalid: getShortTextFromPage(accountSetupPageContent, 'emailInvalid'),
      emailRequired: getShortTextFromPage(accountSetupPageContent, 'emailRequired'),
      firstNameInvalid: getShortTextFromPage(accountSetupPageContent, 'firstNameInvalid'),
      firstNameRequired: getShortTextFromPage(accountSetupPageContent, 'firstNameRequired'),
      lastNameInvalid: getShortTextFromPage(accountSetupPageContent, 'lastNameInvalid'),
      lastNameRequired: getShortTextFromPage(accountSetupPageContent, 'lastNameRequired'),
      continueButtonLabel: getBySlug(commonElements?.shortTextFields, 'continueButtonLabel')?.value,
      phoneNumber: getShortTextFromPage(accountSetupPageContent, 'phoneNumber'),
      postalCodeInvalid: getShortTextFromPage(accountSetupPageContent, 'postalCodeInvalid'),
      postalCodeRequired: getShortTextFromPage(accountSetupPageContent, 'postalCodeRequired'),
      provinceInvalid: getShortTextFromPage(accountSetupPageContent, 'provinceInvalid'),
      provinceRequired: getShortTextFromPage(accountSetupPageContent, 'provinceRequired'),
      securityAnswerErrorRequired: getShortTextFromPage(
        accountSetupPageContent,
        'securityAnswerErrorRequired'
      ),
      securityQuestionErrorRequired: getShortTextFromPage(
        accountSetupPageContent,
        'securityQuestionErrorRequired'
      ),
      step: getShortTextFromPage(accountSetupPageContent, 'step')
    }
  }, [pageContent, language, userType])

  const {
    accountSetupHeader,
    firstNameRequired,
    lastNameRequired,
    firstNameInvalid,
    lastNameInvalid,
    continueButtonLabel
  } = text

  const history = useHistory()

  const accountSetupPageState = useSelector((state) => state.accountSetupPage)

  const location = useLocation()

  const {
    [ACCOUNT_SETUP_STATE.IS_COMPLETE]: isComplete,
    [ACCOUNT_SETUP_STATE.FIRST_NAME]: firstName,
    [ACCOUNT_SETUP_STATE.LAST_NAME]: lastName,
    [ACCOUNT_SETUP_STATE.PIN]: pin,
    [ACCOUNT_SETUP_STATE.LANGUAGE]: preferredLanguage
  } = accountSetupPageState

  const tagManagerInfo = useTagManagerInfo({
    customFields: {
      plan_name: plan?.sluggedName || 'NA',
      plan_cost: plan?.value || 'NA',
      customer_ban: 'NA',
      customer_quote_id: accountInfo?.quoteId || quoteInfo?.quoteId || 'NA',
      dealer_info: userType === Sites.dealer ? identity : 'NA',
      journey_type: 'NA'
    }
  })

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, ANALYTICS_EVENT_TYPES.PAGE_VIEW, region, language, tagManagerInfo)
    )
  }

  useEffect(() => {
    if (userType === Sites.dealer && identity) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language, identity])

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  useEffect(() => {
    if (featureFlags?.[0]?.showSplashing) {
      history.push(isDealer ? dealerActivationPaths.Splash : consumerActivationPaths.Splash)
    }
  }, [featureFlags, isDealer, history])

  useEffect(() => {
    if (userType === Sites.consumer) {
      // TODO: Delete the following line when login flow is setup
      setLoggedInUser(true)
      dispatch(logIn())
    }
  }, [])

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  const nameRef = useRef(null)
  const pinRef = useRef(null)

  // Prevent rendering account setup content while the splash redirect is in flight.
  // Only suppress rendering once featureFlags are confirmed loaded, so we don't blank
  // the page on the first paint before the flags arrive. The redirect itself is handled
  // by the useEffect above.
  const featureFlagsLoaded = Array.isArray(featureFlags) && featureFlags.length > 0
  const showSplashingFlag = featureFlagsLoaded && featureFlags?.[0]?.showSplashing
  if (showSplashingFlag) {
    return null
  }

  const updateQuote = async () => {
    try {
      const fullName = `${firstName} ${lastName}`
      const input = {
        email,
        language: preferredLanguage === 0 ? LANGUAGES_CODE.EN : LANGUAGES_CODE.FR,
        fullName,
        dynamicCode: pin
      }
      const response = await setPatchQuote(input)
      return response
    } catch (err) {
      console.log('ERROR', err)
      return err
    }
  }

  const handleNextClick = async () => {
    // eslint-disable-next-line camelcase
    const pushClickAnalytics = ({ click_text, event_type, event_click = ANALYTICS_EVENT_TYPES.CLICK } = {}) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(
        setPageAnalytics(location, 'click', region, language, {
          ...tagManagerInfo,
          click_text
        }, event_type, event_click)
      )
    }

    pushClickAnalytics({ click_text: continueButtonLabel, event_type: `customer clicked on ${continueButtonLabel}` })

    try {
      setLandingLogicLoader('IN_PROGRESS')
      if (isComplete) {
        const response = await updateQuote()
        const nextPagePath = isDealer
          ? dealerActivationPaths.SimSelection
          : consumerActivationPaths.SimSelection

        const splashPagePath = isDealer
          ? dealerActivationPaths.Splash
          : consumerActivationPaths.Splash

        if (response?.data?.accountId) {
          history.push(nextPagePath)
        } else {
          history.push(splashPagePath)
        }
      } else {
        let topError

        if (handleFirstNameBlur() && !topError) {
          topError = nameRef
        }
        if (handleLastNameBlur() && !topError) {
          topError = nameRef
        }
        if (handleBlurPin() && !topError) {
          topError = pinRef
        }
        if (handleBlurConfirmPin() && !topError) {
          topError = pinRef
        }
        if (topError) {
          topError.current.scrollIntoView({
            behavior: 'smooth'
          })
        }
      }

    } finally {
      setLandingLogicLoader(false)
    }
  }

  const setAccountSetupState = (payload) => {
    dispatch(updateAccountSetupState(payload))
  }

  const setAccountSetupPinErrorsState = (payload) => {
    dispatch(updateAccountSetupPinErrorState(payload))
  }

  const handleFirstNameBlur = () => {
    const errorCopy = {
      firstNameRequired,
      firstNameInvalid,
      lastNameRequired,
      lastNameInvalid
    }
    return AccountSetupChangeHandlers[ACCOUNT_SETUP_EVENTS.FIRST_NAME].onBlur(
      accountSetupPageState,
      errorCopy,
      setAccountSetupState
    )
  }

  const handleLastNameBlur = () => {
    const errorCopy = {
      firstNameRequired,
      firstNameInvalid,
      lastNameRequired,
      lastNameInvalid
    }
    return AccountSetupChangeHandlers[ACCOUNT_SETUP_EVENTS.LAST_NAME].onBlur(
      accountSetupPageState,
      errorCopy,
      setAccountSetupState
    )
  }

  const handleBlurPin = () => {
    return AccountSetupChangeHandlers[ACCOUNT_SETUP_EVENTS.PIN].onBlur(
      accountSetupPageState,
      setAccountSetupPinErrorsState
    )
  }

  const handleBlurConfirmPin = () => {
    return AccountSetupChangeHandlers[ACCOUNT_SETUP_EVENTS.CONFIRM_PIN].onBlur(
      accountSetupPageState,
      setAccountSetupPinErrorsState
    )
  }

  return (
    <CheckoutLayout
      heading={
        <Heading2
          className="mt-6 sm:mt-10 max-w-2xl"
          tokens={{ fontSize: 36, lineHeight: 48 / 36 }}
        >
          {accountSetupHeader}
        </Heading2>
      }
      activeStepIndex={PAGE_NUMBER.ACCOUNT_SETUP}
    >
      <Card variant={{ padding: 'intermediate', borderRadius: 'large' }}>
        <Name
          nameRef={nameRef}
          handleFirstNameBlur={handleFirstNameBlur}
          handleLastNameBlur={handleLastNameBlur}
        />
        <Spacer space={4} />
        <Divider />
        <Spacer space={3} />
        <PIN
          pinRef={pinRef}
          handleBlurPin={handleBlurPin}
          handleBlurConfirmPin={handleBlurConfirmPin}
        />
        <Spacer space={4} />
        <Divider />
        <Spacer space={3} />
        <PreferredLanguage tagManagerInfo={tagManagerInfo} />
        <Spacer space={4} />
        <div className="flex justify-start">
          <Button
            variant={{ priority: 'high', width: 'responsive' }}
            tokens={{ borderRadius: 6 }}
            onClick={() => handleNextClick()}
            testId="accountSetup-nextStep"
          >
            {continueButtonLabel}
          </Button>
        </div>
      </Card>
    </CheckoutLayout>
  )
}

export default AccountSetupPage
